import { Star } from "lucide-react";

const GOOGLE_REVIEW_URL =
  "https://www.google.com/search?sca_esv=2965c6137329154f&sxsrf=APpeQnsd77QHGmCTY9pI8pWXdW4wALkIBw:1782538238268&si=APenkKm7iecQ4G6P-TsbSMFKIQtv3EFIqRAFw-i8uEbk55Z-_xMZyrWBCjIjFH9x9ENhN55MwiW7fRkSQmDNmqNODeYGdME_djhxThBO7s0fSykb0Ed91OnnZBWZMqvBYhI-RbhFpppcLnhAp-6L_nZWABM3MQ3WsQ%3D%3D&q=Breeze+Wealth+Management+Reviews&sa=X&ved=2ahUKEwjCgfaz2KaVAxX6HkQIHQQSN64Q0bkNegQINxAD";

export const GoogleRating = ({ light = false, className = "" }) => (
  <a
    href={GOOGLE_REVIEW_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="google-rating-badge"
    aria-label="Read Breeze Wealth Management reviews on Google (opens in a new tab)"
    className={`inline-flex items-center gap-2.5 group transition-opacity duration-200 hover:opacity-80 ${className}`}
  >
    <span className="flex gap-0.5">
      {[...Array(5)].map((_, i) => (
        <Star key={i} size={15} className="text-[#FBBC04]" fill="#FBBC04" />
      ))}
    </span>
    <span
      className={`text-sm font-medium underline-offset-4 group-hover:underline ${
        light ? "text-white/80" : "text-[#334155]"
      }`}
    >
      5-star rated on Google
    </span>
  </a>
);
